export enum FilterLessonStatus {
  currentAssignments = 0,
  lateAssignments = 1,
  revision = 2,
}